module.exports = __webpack_public_path__ + "static/media/b.ff0c77e5.jpg";